import type { CeoBankAccount } from '@shared/api';

/** ИНН с верным контрольным числом (10 цифр у организации, 12 у ИП). */
export function innIsValid(inn: string): boolean {
  if (!/^(\d{10}|\d{12})$/.test(inn) || /^0+$/.test(inn)) return false;
  const d = inn.split('').map(Number);
  const check = (coef: number[], at: number) =>
    (coef.reduce((sum, c, i) => sum + c * d[i], 0) % 11) % 10 === d[at];
  return d.length === 10
    ? check([2, 4, 10, 3, 5, 9, 4, 6, 8], 9)
    : check([7, 2, 4, 10, 3, 5, 9, 4, 6, 8], 10) && check([3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8], 11);
}

/** Чего не хватает счёту, чтобы стать плательщиком в файле для банка (как проверяет выгрузка). */
export function payerGaps(acc: CeoBankAccount): string[] {
  const gaps: string[] = [];
  if (!acc.entity_name.trim()) gaps.push('владелец');
  if (!/^\d{9}$/.test(acc.bik.trim())) gaps.push('БИК');
  if (!/^\d{20}$/.test(acc.corr_account.trim())) gaps.push('корр. счёт');
  const inn = (acc.entity_inn ?? '').trim();
  if (!innIsValid(inn)) gaps.push('ИНН');
  else if (inn.length === 10 && !/^\d{9}$/.test((acc.entity_kpp ?? '').trim())) gaps.push('КПП');
  return gaps;
}
